import Select2DdynamicController from "../select2_dynamic_controller";

export default class extends Select2DdynamicController {
  static values = {
    url: String,
    copyRecordOutside: String,
    orderTypeEqSelector: String,
    orderLocationSelector: String
  }

  init() {
    const init_order_location_eq = document.querySelector(this.orderTypeEqSelectorValue)
    $(this.element).select2(this.select2_options)
    $(this.element).on("select2:select", (e) => {
      const order_location_eq = document.querySelector(this.orderTypeEqSelectorValue)
      const order_location_input = document.querySelector(this.orderLocationSelectorValue)

      order_location_eq.value = this.copyRecordOutsideValue && e.params.data.library_card_type_outside ? init_order_location_eq.value : 2 /* on_premise */;
      order_location_input.dataset["v-Select2OrderLocationFlatpickrDateToValue"] = e.params.data.expiration_date
      order_location_input.disabled = false
    });
  }

  process_results(data) {
    return {
      results: data.data.map(item => {
        return {
          id: item.id,
          text: item.attributes[this.textKeyValue],
          library_card_type_outside: item.attributes["library_card_type_outside"],
          expiration_date: item.attributes["expiration_date"]
        }
      }),
      // define if has more pages
      pagination: { more: !!data.links.next }
    }
  }
}
